<template>
  <div class="cl-inner">

    <!-- 操作 -->
    <div class="person-oper">
      <a-button type="primary" icon="plus" @click="add()">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      class="c-table"
      @change="handleTableChange"
    >
      <span slot="moduleIcon" slot-scope="text,record"><img :src="record.moduleIcon" height="20px" alt="缩略图" @click="show(record.moduleIcon)" @error="errorLoadImg"/></span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="edit(record.id)">修改</a>
          <a-divider type="vertical" />
          <a @click="del(record.id)">删除</a>
        </template>
      </span>
    </a-table>
    <a-modal :maskClosable="false" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" @error="errorLoadImg"/>
    </a-modal>
    <app-module-form-modal ref="appModuleForm"></app-module-form-modal>
  </div>
</template>
<script>
import CTable from "../../components/CTable";
import notification from "ant-design-vue/es/notification";
import appModule from "../../api/appModule";
import AppModuleFormModal from "../appModule/AppModuleFormModal";

const columns = [
  {
    title: "模块名称",
    dataIndex: "moduleName",
    key: "moduleName"
  },
  {
    title: "模块图标",
    dataIndex: "moduleIcon",
    key: "moduleIcon",
    scopedSlots: { customRender: "moduleIcon" }
  },
  // {
  //   title: "城市",
  //   dataIndex: "cityId",
  //   key: "cityId",
  // },
  // {
  //   title: "关联标签",
  //   dataIndex: "tagId",
  //   key: "tagId",
  // },
  {
    title: "显示顺序",
    dataIndex: "seq",
    key: "seq",
  },
  // {
  //   title: "创建时间",
  //   dataIndex: "gmtCreate",
  //   key: "gmtCreate"
  // },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "appModuleList",
  props: ["orgType"],
  data() {
    return {
        previewVisible: false,
        previewImage: '',
        dataSource: [],
        columns,
        loading: false,
        pagination: { 
				showTotal: total => `总共 ${total} 条`, // 显示总数
      },
    };
  },
  components: {
    CTable,AppModuleFormModal
  },
  methods: {

    show(url){
      this.previewImage=url;
      this.previewVisible=true;
    },
    //活动列表
    getAppModuleList(params) {
      this.loading = true;
      appModule.getAppModuleList(params).then(res => {
        // console.log('数据：',res)
        this.pagination = res.data.pagination;
        this.dataSource = res.data.list;
        this.loading = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.getAppModuleList({
        currentPage: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    //新增
    add(value) {
      this.$refs.appModuleForm.init('add',{ id: -1})
    },
    edit(value) {
      this.$refs.appModuleForm.init('edit',{ id: value ? value : -1})
    },
    del(id) {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "您此次操作将会删除此模块，请确认您是否要删除?",
        okText: "是",
        okType: "danger",
        cancelText: "否",
        onOk() {
          appModule.del({ id }).then(res => {
            console.log(res);
            notification.success({
              message: "消息",
              description: "删除成功！"
            });
            that.getAppModuleList({
              currentPage: that.pagination.current
            });
          });
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    }
  },
  created() {
    this.getAppModuleList({currentPage:1,pageSize:10});
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>